import styled, { css } from "styled-components";
import { Tooltip } from "../../Tooltip";

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  /* border-radius: 5px; */

  border: 1px solid grey;
  background-color: #fff;
  padding: 10px;

  & + div {
    margin-top: 10px;
  }

  ${(props) =>
    props.isErrored &&
    css`
      border-color: var(--red);
    `}

  ${(props) =>
    props.isFocused &&
    css`
      border-color: var(--blue);
      color: var(--blue);
      box-shadow: #b1a7a6 0px 0px 10px 1px;
    `}

  ${(props) =>
    props.isFilled &&
    css`
      color: var(--blue);
    `}

  input {
    background: transparent;
    padding: 10px;
    border: 0;
    flex: 1;
    outline: none;
    width: inherit;
  }

  svg {
  }
`;

export const Error = styled(Tooltip)``;
